import {
    SET_CLOSED_BATCHES,
    UPDATE_CLOSED_BATCH,
    SELECT_CLOSED_BATCH,
    ACTIVATE_CLOSED_BATCH,
} from './types';

import {
    getCookie,
    isInternetExplorerNavigator,
    promiseAllSettledPolyfill,
} from 'Functions';
import Globals from '../../Globals';
import BatchesService from 'services/BatchesService';

export const setClosedBatches = payload => {
    return async dispatch => {
        //ASYNC FETCH TO AMAZON

        const jsonToken = getCookie(Globals.COOKIES.JWT);
        const user = getCookie(process.env.REACT_APP_USER_ID);

        if (!jsonToken || !user) return; //Alert message or push to login

        const token = JSON.parse(jsonToken)?.AccessToken;

        const batchesBidsPromises = payload.active.map(batch => {
            return BatchesService.getClosedBatchBids(
                `${
                    process.env.REACT_APP_AWS_GET_BATCH_BIDS_URL
                }?user=${encodeURIComponent(user.toUpperCase())}`,
                process.env.REACT_APP_AWS_BIDS_APIKEY_NAME,
                process.env.REACT_APP_AWS_BIDS_APIKEY_VALUE,
                batch.LotId,
                token
            );
        });

        const response = isInternetExplorerNavigator()
            ? await promiseAllSettledPolyfill(batchesBidsPromises)
            : await Promise.allSettled(batchesBidsPromises); //Not supported by IE

        // {status: "fulfilled", value: {...AMAZON BATCH DATA}}
        // {status: "rejected"} => no bids in amazon

        const mappedBatches = payload.active.map((batch, index) =>
            response[index]?.value?.data
                ? {
                      ...batch,
                      ...response[index]?.value?.data,
                  }
                : batch
        );

        //Setup array of batches
        dispatch({
            type: SET_CLOSED_BATCHES,
            payload: {
                active: mappedBatches,
                upcoming: payload.upcoming,
            },
        });
    };
};

export const updateBatch = ([LotId]) => async dispatch => {
    //payload [LotId]

    const jsonToken = getCookie(Globals.COOKIES.JWT);
    const user = getCookie(process.env.REACT_APP_USER_ID);

    if (!jsonToken || !user)
        return alert('Connection failed, relog and try again'); //Alert message or push to login

    const token = JSON.parse(jsonToken)?.AccessToken;

    const response = await BatchesService.getClosedBatchBids(
        `${
            process.env.REACT_APP_AWS_GET_BATCH_BIDS_URL
        }?user=${encodeURIComponent(user.toUpperCase())}`,
        process.env.REACT_APP_AWS_BIDS_APIKEY_NAME,
        process.env.REACT_APP_AWS_BIDS_APIKEY_VALUE,
        LotId,
        token
    );

    if (response.data) {
        dispatch({
            type: UPDATE_CLOSED_BATCH,
            payload: { LotId, ...response.data },
        });
    }
};

export const disableClosedBatch = ([LotId]) => ({
    //payload [LotId]
    type: UPDATE_CLOSED_BATCH,
    payload: { LotId, Sold: true },
});

export const selectClosedBatch = payload => ({
    type: SELECT_CLOSED_BATCH,
    payload,
});

export const activateBatch = payload => ({
    //payload LotId
    type: ACTIVATE_CLOSED_BATCH,
    payload,
});
